import { render } from "./BuyAVehicle.vue?vue&type=template&id=473d76bf&lang=true"
import script from "./BuyAVehicle.vue?vue&type=script&lang=js"
export * from "./BuyAVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__